import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DataTableSortType } from './sort.type';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
function DataTableHeaderButtonComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 3);
    i0.ɵɵelementContainerEnd();
} }
function DataTableHeaderButtonComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 4);
    i0.ɵɵelementContainerEnd();
} }
function DataTableHeaderButtonComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 5);
    i0.ɵɵelementContainerEnd();
} }
export class DataTableHeaderButtonComponent {
    constructor() {
        this.sortChange = new EventEmitter();
        this.ariaButtonLabel = 'Change Sorting';
    }
    changeSort() {
        const { property, sortType = DataTableSortType.NONE } = this.column;
        this.sortChange.emit({ property, sortType });
    }
    getSortAriaLabel(column) {
        const label = `${column.header} sort`;
        let sortStatus = '';
        switch (column.sortType) {
            case DataTableSortType.ASC:
                sortStatus = 'ascending';
                break;
            case DataTableSortType.DESC:
                sortStatus = 'descending';
                break;
            case DataTableSortType.NONE:
            default:
                sortStatus = 'unsorted';
                break;
        }
        return `${label} ${sortStatus}`;
    }
}
DataTableHeaderButtonComponent.ɵfac = function DataTableHeaderButtonComponent_Factory(t) { return new (t || DataTableHeaderButtonComponent)(); };
DataTableHeaderButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DataTableHeaderButtonComponent, selectors: [["DataTable-table-header-button"]], inputs: { column: "column" }, outputs: { sortChange: "sortChange" }, decls: 7, vars: 6, consts: [["type", "button", 1, "sort-button", 3, "name", "click"], ["aria-hidden", "true", 1, "header-text", "pointer"], [4, "ngIf"], [1, "dpg-icon", "dpg-icon-system-sort-white"], [1, "dpg-icon", "dpg-icon-system-sort-up-white"], [1, "dpg-icon", "dpg-icon-system-sort-down-white"]], template: function DataTableHeaderButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function DataTableHeaderButtonComponent_Template_button_click_0_listener() { return ctx.changeSort(); });
        i0.ɵɵelementStart(1, "span", 1);
        i0.ɵɵtemplate(2, DataTableHeaderButtonComponent_ng_container_2_Template, 2, 0, "ng-container", 2);
        i0.ɵɵtemplate(3, DataTableHeaderButtonComponent_ng_container_3_Template, 2, 0, "ng-container", 2);
        i0.ɵɵtemplate(4, DataTableHeaderButtonComponent_ng_container_4_Template, 2, 0, "ng-container", 2);
        i0.ɵɵelementContainerStart(5);
        i0.ɵɵtext(6);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("name", ctx.column.header);
        i0.ɵɵattribute("aria-label", ctx.getSortAriaLabel(ctx.column));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.column.sortType === undefined || ctx.column.sortType === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.column.sortType === 1);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.column.sortType === 2);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.column.header);
    } }, dependencies: [i1.NgIf], styles: ["\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataTableHeaderButtonComponent, [{
        type: Component,
        args: [{ selector: 'DataTable-table-header-button', template: `
    <button
      type="button"
      class="sort-button"
      [name]="column.header"
      [attr.aria-label]="getSortAriaLabel(column)"
      (click)="changeSort()"
    >
      <span class="header-text pointer" aria-hidden="true">
        <ng-container *ngIf="column.sortType === undefined || column.sortType === 0">
          <i class="dpg-icon dpg-icon-system-sort-white"> </i>
        </ng-container>
        <ng-container *ngIf="column.sortType === 1">
          <i class="dpg-icon dpg-icon-system-sort-up-white"> </i>
        </ng-container>
        <ng-container *ngIf="column.sortType === 2">
          <i class="dpg-icon dpg-icon-system-sort-down-white"> </i>
        </ng-container>
        <ng-container>{{ column.header }}</ng-container>
      </span>
    </button>
  `, styles: ["/*# sourceMappingURL=table.component.css.map */\n"] }]
    }], null, { column: [{
            type: Input
        }], sortChange: [{
            type: Output
        }] }); })();
